/* eslint-disable no-mixed-operators */
import React from "react";
import classes from "./NotificationModal.module.scss";
import { dismissOrderNotifications, getExpiringSoonOrExpiredOrders } from "./services";
import { IOrderReportView } from "./types";
import { ModalOverlay } from "./ModalOverlay";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { confirmDialog } from "../Dialog/actions";

export const IS_REMIND_LATER = "isRemindLater";
class Backdrop extends React.Component<any, any> {
  render() {
    return (
      <div className={classes.backdrop} onClick={this.props.onClick}></div>
    );
  }
}

interface IState {
  isShow: boolean,
  orderItems: IOrderReportView[] | undefined
}

interface IProps {
  confirmDialog: typeof confirmDialog,
}

class NotificationModal extends React.Component<IProps, IState> {

  constructor(props: any) {
    super(props);
    this.state = {
      isShow: true,
      orderItems: [],
    };
  }

  async componentDidMount(): Promise<void> {
    const isRemindLater = !!sessionStorage.getItem(IS_REMIND_LATER);
    const results: IOrderReportView[] = isRemindLater === false ? await getExpiringSoonOrExpiredOrders() : [];
    !!results && results.length > 0 && this.setState({
      orderItems: results
    })
  }

  onClickHandler = () => {
    this.setState({
      isShow: !this.state.isShow,
    });
  };


  onDismissAllHandler = async () => {
    const { orderItems } = this.state
    const ids: string[] = !!orderItems && orderItems.length > 0 && orderItems.map(item => item.orderId) || []
    this.props.confirmDialog("Please confirm your choice",
      "You won’t see these notifications anymore",
      false,
      async () => {
        ids.length > 0 && await dismissOrderNotifications(ids)
        this.setState({
          isShow: false
        })
      })
  };

  onRemindLaterHandler = () => {
    sessionStorage.setItem(IS_REMIND_LATER, "true");
    this.setState({
      isShow: false,
    });
  };

  ModalComponent = (state: any) => {
    return (
      !!this.state.orderItems && this.state.orderItems.some((item: any) => item.isRemind === true) && <div>
        {ReactDOM.createPortal(
          <Backdrop onClick={this.onClickHandler} />,
          document.getElementById("backdrop-root")!
        )}
        {ReactDOM.createPortal(
          <ModalOverlay
            title="Dear FEBER users, your report access is about to expire!"
            message="Please keep track of the expiration dates of your orders below."
            orderItems={state.orderItems}
            onRemindLater={this.onRemindLaterHandler}
            onDismissAll={this.onDismissAllHandler}
          />,
          document.getElementById("overlay-root")!
        )}
      </div>
    );
  };
  checkIfIsRemindLater = !!sessionStorage.getItem(IS_REMIND_LATER);
  render() {
    return (
      <React.Fragment>
        {
          this.state.isShow &&
          !!this.state.orderItems &&
          this.state.orderItems.length > 0 &&
          this.ModalComponent(this.state)}
      </React.Fragment>
    );
  }
}

export default connect(null, { confirmDialog })(NotificationModal);
